import axios from 'axios';

const url = process.env.VUE_APP_API

export default {
    name: 'dataService',
    /**
     * Get data from the endpoint via GET method
     * @param {Endpoint address} endpoint
     */
    async getAllDataGet(endpoint) {
        const response = await axios.get(url + endpoint);
        return JSON.stringify(response.data);
    },
    /**
     * Get data from the endpoint via POST method
     * @param {Endpoint address} endpoint
     * @param {Endpoint parameters} params
     */
    async getAllDataPost(endpoint, fields, where = undefined) {
        const response = await axios.post(url + endpoint, {Attributes: fields, Where: where});
        return JSON.stringify(response.data);
    },
    /**
     * Delete data on the endpoint
     * @param {Endpoint parameters - we suppose id and TablesEnum} params
     */
    async dataDeleteById(id, tablesEnum) {
        const response = await axios.post(url + 'dataDeleteById/', { Id: id, TablesEnum: tablesEnum });
        return JSON.stringify(response.data);
    },
    /**
     * Insert or edit data on endpoint
     * @param {Endpoint parameters} params
     */
    async upsert(tablesEnum, params) {
        const response = await axios.post(url + 'upsert/', {TablesEnum: tablesEnum, ClientSiteObject: params});
        return JSON.stringify(response.data);
    },
    
    async getAllUsers(fields = undefined) {
        return await this.getAllDataPost('getAllUsers/', fields);
    },
    async getAllUserRoles(fields = undefined) {
        return await this.getAllDataPost('getAllUserRoles/', fields);
    },
    async getAllUserPermissions(fields = undefined) {
        return await this.getAllDataPost('getAllUserPermissions/', fields);
    },
    async getAllUserRolePermissions(fields = undefined, where = undefined) {
        return await this.getAllDataPost('getAllUserRolePermissions/', fields, where);
    },
    async getAllInsuranceEventTypes(fields = undefined, where = undefined) {
        return await this.getAllDataPost('getAllInsuranceEventTypes/', fields, where);
    },
    async getAllReportDamageTypes(fields = undefined, where = undefined) {
        return await this.getAllDataPost('getAllReportDamageTypes/', fields, where);
    },
    async getAllDamagedTypes(fields = undefined, where = undefined) {
        return await this.getAllDataPost('getAllDamagedTypes/', fields, where);
    },
    async getOtherAuthorizedPersonTypes(fields = undefined, where = undefined) {
        return await this.getAllDataPost('getOtherAuthorizedPersonTypes/', fields, where);
    },
    async getInsuranceCompanies(fields = undefined) {
        return await this.getAllDataPost('getInsuranceCompanies/', fields);
    },

    async saveRolePermissions(rolePermissions) {
        const response = await axios.post(url + '/saveRolePermissions', {TablesEnum: $TablesEnum.userRolePermission, RolePermissions: rolePermissions});
        return JSON.stringify(response.data);
    },
    async sendEmail(emailType, emailAddress) {
        await axios.post(url + 'sendEmail/', {EmailType: emailType, EmailAddress: emailAddress});
    },
    async changePassword(oldPassword, newPassword, userId) {
        await axios.post(url + 'changePassword/', {OldPassword: oldPassword, NewPassword: newPassword, UserId: userId});
    },
    async checkUserDuplicity(userObject) {
        const response = await axios.post(url + 'checkUserDuplicity/', {UserObject: userObject});
        return JSON.stringify(response.data);
    },
    async resetUserPermissions() {
        const response = await axios.post(url + 'resetUserPermissions/');
        return JSON.stringify(response.data);
    },
    async deactiveUserPermission(id) {
        const response = await axios.post(url + 'deactiveUserPermission/', {Id: id});
        return JSON.stringify(response.data);
    },
    async getAresSubjectByIc(ic) {
        const response = await axios.get(url + 'getAresSubjectByIc?ic=' + ic);
        return JSON.stringify(response.data);
    }
};